import { useState, useEffect } from "react";
import HamburgerNavMenu from "../Hamburger/Hamburger";
import MobileNavmenu from "../Mobile/MobileNav";
import DesktopNavmenu from "../Desktop/DesktopNav";


function ResponsiveNavmenu() {
  const [width, setWidth]                   = useState<number>();
  const [mobileNavOpen, setMobileNavOpen]   = useState<boolean>(false);

  useEffect(() => {
    const resize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", resize);
  }, 
  [width]);


  const showHideMobileNav = (bool: boolean): void => {
    setMobileNavOpen(bool);
  };


  const showMenu = () => {
    if (window.innerWidth as number < 1024 && mobileNavOpen) {
      return <>
        <HamburgerNavMenu mobileNavOpen={mobileNavOpen} showHideMobile={showHideMobileNav} />
        <MobileNavmenu showHideMobile={showHideMobileNav} /> 
      </>
    }
    if (window.innerWidth as number < 1024) {
      return <HamburgerNavMenu mobileNavOpen={mobileNavOpen} showHideMobile={showHideMobileNav} />
    }
    
    return <DesktopNavmenu />
  };

  return showMenu();
}

export default ResponsiveNavmenu;
